export interface MetaUrlGq {
  url?: string;
  contentTaskId?: number;
  primaryKeyword?: string;
  secondarKeyword?: string;
}

export const MetaUrlGqProps = `
    url
    contentTaskId
    primaryKeyword
    secondaryKeyword
`;
